var map = {
	"./": 9381,
	"./about-us": 6350,
	"./about-us.tsx": 6350,
	"./airtime-transactions": 289,
	"./airtime-transactions.tsx": 289,
	"./airtime/[slug]": 2577,
	"./airtime/[slug].tsx": 2577,
	"./betting-done": 3947,
	"./betting-done.tsx": 3947,
	"./betting-order": 5849,
	"./betting-order.tsx": 5849,
	"./betting-summary": 1037,
	"./betting-summary.tsx": 1037,
	"./blog": 489,
	"./blog.tsx": 489,
	"./bodies-done": 4798,
	"./bodies-done.tsx": 4798,
	"./bodies-order": 5370,
	"./bodies-order.tsx": 5370,
	"./bodies-summary": 7332,
	"./bodies-summary.tsx": 7332,
	"./bulk-airtime-done": 9590,
	"./bulk-airtime-done.tsx": 9590,
	"./bulk-airtime-order": 1015,
	"./bulk-airtime-order.tsx": 1015,
	"./bulk-airtime-summary": 8571,
	"./bulk-airtime-summary.tsx": 8571,
	"./cabletv-done": 9015,
	"./cabletv-done.tsx": 9015,
	"./cabletv-order": 9846,
	"./cabletv-order.tsx": 9846,
	"./cabletv-summary": 4343,
	"./cabletv-summary.tsx": 4343,
	"./cabletv-transactions": 106,
	"./cabletv-transactions.tsx": 106,
	"./cabletv/[slug]": 781,
	"./cabletv/[slug].tsx": 781,
	"./contact-us": 9255,
	"./contact-us.tsx": 9255,
	"./dashboard": 1692,
	"./dashboard.tsx": 1692,
	"./data-done": 3774,
	"./data-done.tsx": 3774,
	"./data-order": 5454,
	"./data-order.tsx": 5454,
	"./data-select": 3721,
	"./data-select.tsx": 3721,
	"./data-summary": 6033,
	"./data-summary.tsx": 6033,
	"./data-transactions": 1201,
	"./data-transactions.tsx": 1201,
	"./data/[slug]": 4731,
	"./data/[slug].tsx": 4731,
	"./education-done": 3457,
	"./education-done.tsx": 3457,
	"./education-order": 4878,
	"./education-order.tsx": 4878,
	"./education-summary": 5898,
	"./education-summary.tsx": 5898,
	"./electricity-done": 5513,
	"./electricity-done.tsx": 5513,
	"./electricity-order": 8660,
	"./electricity-order.tsx": 8660,
	"./electricity-summary": 610,
	"./electricity-summary.tsx": 610,
	"./electricity-transactions": 5029,
	"./electricity-transactions.tsx": 5029,
	"./electricity/[slug]": 2883,
	"./electricity/[slug].tsx": 2883,
	"./faq": 5021,
	"./faq.tsx": 5021,
	"./forgot-password": 1048,
	"./forgot-password.tsx": 1048,
	"./govt-levy-done": 5498,
	"./govt-levy-done.tsx": 5498,
	"./govt-levy-order": 5904,
	"./govt-levy-order.tsx": 5904,
	"./govt-levy-summary": 1674,
	"./govt-levy-summary.tsx": 1674,
	"./index": 9381,
	"./index.tsx": 9381,
	"./login": 6029,
	"./login.tsx": 6029,
	"./multiple-airtime-done": 5834,
	"./multiple-airtime-done.tsx": 5834,
	"./multiple-airtime-order": 8776,
	"./multiple-airtime-order.tsx": 8776,
	"./multiple-airtime-select": 3238,
	"./multiple-airtime-select.tsx": 3238,
	"./multiple-airtime-summary": 6053,
	"./multiple-airtime-summary.tsx": 6053,
	"./privacy-policy": 4847,
	"./privacy-policy.tsx": 4847,
	"./profile": 2062,
	"./profile-cards": 3134,
	"./profile-cards.tsx": 3134,
	"./profile.tsx": 2062,
	"./recharge-done": 7983,
	"./recharge-done.tsx": 7983,
	"./recharge-order": 6143,
	"./recharge-order.tsx": 6143,
	"./recharge-payment": 7399,
	"./recharge-payment.tsx": 7399,
	"./recharge-summary": 4669,
	"./recharge-summary.tsx": 4669,
	"./select-betting": 1486,
	"./select-betting.tsx": 1486,
	"./select-bodies": 2326,
	"./select-bodies.tsx": 2326,
	"./select-bulk-airtime": 6170,
	"./select-bulk-airtime.tsx": 6170,
	"./select-cabletv": 4936,
	"./select-cabletv.tsx": 4936,
	"./select-education": 9553,
	"./select-education.tsx": 9553,
	"./select-electricity": 5833,
	"./select-electricity.tsx": 5833,
	"./select-govt-levy": 3880,
	"./select-govt-levy.tsx": 3880,
	"./select-insurance": 1142,
	"./select-insurance.tsx": 1142,
	"./select-recharge": 7330,
	"./select-recharge.tsx": 7330,
	"./signup": 1498,
	"./signup.tsx": 1498,
	"./terms-conditions": 9953,
	"./terms-conditions.tsx": 9953,
	"./transactions": 9595,
	"./transactions-details": 8364,
	"./transactions-details.tsx": 8364,
	"./transactions.tsx": 9595,
	"./transactions/[slug]": 4960,
	"./transactions/[slug].tsx": 4960,
	"./verify-email": 6017,
	"./verify-email.tsx": 6017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2150;